module.exports = {
      id: "home-usage",
      viewBox: "0 0 15.417 13.987",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#home",
      toString: function () {
        return this.url;
      }
    }